"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSectionItemSaga = exports.removeSectionItemHandler = void 0;
var tslib_1 = require("tslib");
var eventDispatcher_1 = require("../../store/_infra/eventDispatcher");
var general_1 = require("../../events/general");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var effects_1 = require("redux-saga/effects");
var layoutValidation_1 = require("./validation/layoutValidation");
var layout_1 = require("../../events/layout");
var layout_2 = require("../../store/layout");
function validateAndResolve(commandCtx) {
    var ctx = commandCtx.ctx, _a = commandCtx.cmd.payload, sectionIndex = _a.sectionIndex, itemIndex = _a.itemIndex, layout = commandCtx.layout;
    if (!layoutValidation_1.validateSectionExists(layout, sectionIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, commandCtx.originalCmd, "Attempting to remove item from non-existent section at " + sectionIndex + ". There are only " + layout.sections.length + " sections.");
    }
    var fromSection = layout.sections[sectionIndex];
    if (!layoutValidation_1.validateItemExists(fromSection, itemIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, commandCtx.originalCmd, "Attempting to remove non-existent item from index " + itemIndex + " in section " + sectionIndex + ". There are only " + fromSection.items.length + " items in this section.");
    }
    var itemToRemove = fromSection.items[itemIndex];
    return {
        fromSection: fromSection,
        itemToRemove: itemToRemove,
    };
}
function removeSectionItemHandler(ctx, cmd) {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(removeSectionItemSaga, ctx, cmd)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
exports.removeSectionItemHandler = removeSectionItemHandler;
function removeSectionItemSaga(ctx, cmd, originalCmd) {
    var commandCtx, _a, _b, fromSection, itemToRemove, _c, sectionIndex, itemIndex, eager, stashIdentifier, sectionWithEmptyItems;
    if (originalCmd === void 0) { originalCmd = cmd; }
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = {
                    ctx: ctx,
                    cmd: cmd,
                    originalCmd: originalCmd
                };
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectLayout)];
            case 1:
                commandCtx = (_a.layout = _d.sent(),
                    _a);
                _b = validateAndResolve(commandCtx), fromSection = _b.fromSection, itemToRemove = _b.itemToRemove;
                _c = cmd.payload, sectionIndex = _c.sectionIndex, itemIndex = _c.itemIndex, eager = _c.eager, stashIdentifier = _c.stashIdentifier;
                if (!(eager && fromSection.items.length === 1)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(layout_2.layoutActions.removeSection({
                        index: sectionIndex,
                        stashIdentifier: stashIdentifier,
                        undo: {
                            cmd: originalCmd,
                        },
                    }))];
            case 2:
                _d.sent();
                sectionWithEmptyItems = tslib_1.__assign(tslib_1.__assign({}, fromSection), { items: [] });
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(layout_1.layoutSectionItemRemoved(ctx, itemToRemove, itemIndex, sectionWithEmptyItems, stashIdentifier, cmd.correlationId))];
            case 3:
                _d.sent();
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(layout_1.layoutSectionRemoved(ctx, sectionWithEmptyItems, sectionIndex, true, undefined, cmd.correlationId))];
            case 4:
                _d.sent();
                return [3 /*break*/, 8];
            case 5: return [4 /*yield*/, effects_1.put(layout_2.layoutActions.removeSectionItem({
                    sectionIndex: sectionIndex,
                    itemIndex: itemIndex,
                    stashIdentifier: stashIdentifier,
                    undo: {
                        cmd: originalCmd,
                    },
                }))];
            case 6:
                _d.sent();
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(layout_1.layoutSectionItemRemoved(ctx, itemToRemove, itemIndex, undefined, stashIdentifier, cmd.correlationId))];
            case 7:
                _d.sent();
                _d.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
exports.removeSectionItemSaga = removeSectionItemSaga;
//# sourceMappingURL=removeSectionItemHandler.js.map